//cd003 plugins/icons step2
import svg_set1 from './svg_set1'
import svg_set2 from './svg_set2'


export default {
    install(Vue, options) {
        Vue.mixin({
            data: () => ({
                iconSets: {
                    ...svg_set1,
                    ...svg_set2,

                } 

            })
        });
    }
};



// WEBPACK FOOTER //
// ./src/utils/icons/index.js